import { render, staticRenderFns } from "./StaffList.vue?vue&type=template&id=63c539ac&"
import script from "./StaffList.vue?vue&type=script&lang=js&"
export * from "./StaffList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports